<ng-template #loading>
    <app-loading></app-loading>
</ng-template>

<ng-container *ngIf="priceCodes != null; else loading">
<form [formGroup]="form" class="d-flex flex-column gap-3">
  <div class="d-flex align-items-center gap-2">
    <div>
    <h2>Price Codes</h2>
    @if (productId && productName)
    {
    <h6 class="text-muted">{{productName}}</h6>
    }
    </div>
    <div class="ms-auto">
      <button type="button" class="btn btn-sm btn-primary" (click)="addRow()">
        Add Code
      </button>
    </div>
  </div>

  <div formArrayName="priceCodes" class="d-flex flex-column gap-3">
    <div
      class="card shadow-sm"
      *ngFor="let row of priceCodesFA.controls; index as i; trackBy: trackByIndex"
      [formGroupName]="i"
    >
      <div class="card-body">
        <div class="row g-3 align-items-start">
          <!-- Type -->
          <div class="col-12 col-md-3">
            <label class="form-label">Type</label>
            <select class="form-select" formControlName="type">
              <option value="list">list</option>
              <option value="direct">direct</option>
              <option value="dealer">dealer</option>
            </select>
          </div>

          <!-- Code (composed from codeType/bulkQty) -->
          <div class="col-12 col-md-3">
            <label class="form-label">Code</label>
            
            <div class="input-group">
              <select class="form-select" formControlName="codeType">
                <option value="BASE">BASE</option>
                <option value="BULK">BULK</option>
              </select>
              @if (row.get('codeType')?.value === 'BULK')
              {
              <input
                type="number"
                min="1"
                class="form-control"
                placeholder="Qty"
                formControlName="bulkQty"
              />
              }

            </div>

            <div class="text-form">
              Final: <code>{{ row.get('code')?.value }}</code>
            </div>
          </div>

          <!-- Price -->
          <div class="col-12 col-md-3">
            <label class="form-label">Price</label>
            <!-- Your custom currency input -->
            <dai-currency-input formControlName="price"></dai-currency-input>
            <div class="invalid-feedback d-block" *ngIf="row.get('price')?.touched && row.get('price')?.invalid">
              <ng-container *ngIf="row.get('price')?.errors?.['required']">Price is required.</ng-container>
              <ng-container *ngIf="row.get('price')?.errors?.['min']">Price must be greater than 0.</ng-container>
            </div>
          </div>

          <div class="col-12 col-md-3 d-flex justify-content-end">
            <button type="button" class="btn btn-outline-danger" (click)="removeRow(i)">
              Remove
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Empty state -->
    <div class="text-center text-muted" *ngIf="priceCodesFA.length === 0">
      No price codes yet. Click <b>Add Code</b> to create one.
    </div>
  </div>

  <div class="d-flex justify-content-end">
    <button type="button" class="btn btn-success" (click)="save()" [disabled]="form.invalid">
      Save Changes
    </button>
  </div>
</form>
</ng-container>
